import { Navigate } from "react-router-dom";

export default function Signup() {
  return <Navigate to="/request-join" replace />;
}
